import { Button, Card, CardContent, CardHeader } from "@mui/material";
import MUIDataTable from "mui-datatables";

const ViewParticipants = (props) => {
  const { participants, setComment, setViewComment ,systemSettings} = props;
  const mainBackground = systemSettings?.mainBackground;

  const columns = [
    {
      name: "names",
      label: "Name",

      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({
          style: {
            color: "white",
            backgroundColor: mainBackground
          }
        })
      },

    },
    {
      name: "phoneNo",
      label: "Phone Number",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({
          style: {
            color: "white",
            backgroundColor: mainBackground
          }
        })
      }
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({
          style: {
            color: "white",
            backgroundColor: mainBackground
          }
        })
      }
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({
          style: {
            color: "white",
            backgroundColor: mainBackground
          }
        }),
        customBodyRender: (status) => status === "confirmed" ? (
          <button className="text-success fw-bolder ">
            {status}
          </button>
        ) : (
          <button className="text-danger fw-bolder  ">
            {status}
          </button>
        )
      }
    },
    {
      name: "comment",
      label: "Comment",
      options: {
        filter: true,
        sort: false,
        setCellHeaderProps: () => ({
          style: {
            color: "white",
            backgroundColor: mainBackground
          }
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => participants[rowIndex]?.comment ? <Button
          style={{ color: mainBackground }}
          onClick={() => {
            setComment(participants[rowIndex]?.comment); setViewComment(true)
          }}><i className="fa fa-info-circle fa-md me-1" /> View </Button> : null
      }
    },
  ];

  return (
    <Card>
      <CardContent>
        <MUIDataTable
          title="Meeting Participants"
          className="table-responsive"
          data-testid="participants-table"
          data={participants}
          columns={columns}
          options={{
            enableNestedDataAccess: ".",
            elevation: 0,
            setTableProps: () => {
              return {
                size: "small",
              };
            },
          }}
        />
      </CardContent>
    </Card>
  );
};
export default ViewParticipants